import { Tooltip } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import PassTypeModal from "./PassTypeModal";
import {
  deletePassTypeById,
  getAllPassTypeList,
  passTypeBySearchString,
} from "../../services/PassTypeService";
import LoadingSpinner from "../../../../../common/components/loadingspinner/loadingSpinner";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../../../common/components/ConfirmationModal";
import SearchDropdown from "../../../../../common/components/FormFields/searchDropdown";
import CommonMasterPaginationTable from "../../../../../common/components/CommonTable/CommonMasterPaginationTable";
import {
  errorAlert,
  successAlert,
} from "../../../../../common/components/Toasts/CustomToasts";
import { UseCheckConsecutiveCharacters } from "../../../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import CommonBackDrop from "../../../../../common/components/CommonBackDrop/CommonBackDrop";
import { DeleteIcon, EditIcon } from "../../../../../assets/CommonAssets";
import { useLocation } from "react-router-dom";

const UserAction = [
  {
    id: 1,
    permission: "Create",
    isAction: false,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },

  {
    id: 2,
    permission: "Edit",
    isAction: true,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
  {
    id: 3,
    permission: "Delete",
    isAction: true,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
];

function PassType() {
  const location = useLocation();
  const { control, watch, setValue, register } = useForm();
  const [userAction, setUserAction] = useState(UserAction);
  const [addNewPassTypeModal, setAddNewPassTypeModal] = useState(false);
  const [dataResult, setDataResult] = useState([]);
  const [passTypeOptions, setPassTypeOptions] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [isBackDrop, setIsBackdrop] = useState(false);
  const [isShowSpinner, setIsShowSpinner] = useState(false);
  const [searchString, setSearchString] = useState(null);

  const [listingObject, setListingObject] = useState({
    page: 0,
    size: rowsPerPage,
    searchString: "",
    searchId: searchString?.value ? searchString?.value : null,
    menuId: location?.state?.menuId,
  });
  console.log("locationlocationlocation", location);

  const populateTable = (forPagination) => {
    let tempObj = {
      searchString: "",
      page: !forPagination ? 0 : page,
      size: rowsPerPage,
      searchId: searchString?.id ? searchString?.id : null,
      menuId: location?.state?.menuId,
    };
    if (page === 0) {
      setIsShowSpinner(true);
    }
    getAllPassTypeList(tempObj)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          if (forPagination === true) {
            setDataResult((prevData) => [...prevData, ...res.result]);
            setIsShowSpinner(false);
          } else {
            setDataResult(res.result);
            setIsShowSpinner(false);
            setPage(0);
          }
          setCount(res.count);
        } else {
          errorAlert(res.message);
          setIsShowSpinner(false);
        }
      })
      .catch((error) => {
        setIsShowSpinner(false);
      });
  };

  // // Function to handle the deletion confirmation
  const handleConfirmToDelete = () => {
    setIsBackdrop(true);
    deletePassTypeById(selectedRow?.Id)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 202) {
          populateTable();
          setIsBackdrop(false);
          setDeleteConfirmationModal(false);
          setSelectedRow(null);
          successAlert(res.message);
        }
      })
      .catch((error) => {
        errorAlert(error.message);
        setIsBackdrop(false);
      });
  };

  const renderInput = React.useCallback((row, index, header) => {
    return (
      <div className="py-1">
        {header === "Duration" && (
          <p>{row["Duration"] ? row["Duration"] : "-"}</p>
        )}
        {header === "Time Format" && (
          <p>{row["Time Format"] ? row["Time Format"] : "-"}</p>
        )}
      </div>
    );
  }, []);

  const renderActions = (row, index) => {
    return (
      <div className="flex gap-1">
        {userAction.map((option) => {
          return (
            <>
              {option.isAction === true && option.permission === "Edit" ? (
                <Tooltip title="Edit">
                  <button
                    type={"button"}
                    onClick={() => {
                      setSelectedRow(row);
                      setAddNewPassTypeModal(true);
                    }}
                  >
                    <EditIcon />
                  </button>
                </Tooltip>
              ) : null}
              {option.isAction === true && option.permission === "Delete" ? (
                <Tooltip title="Delete">
                  <button
                    type={"button"}
                    onClick={() => {
                      setSelectedRow(row);
                      setDeleteConfirmationModal(true);
                    }}
                  >
                    <DeleteIcon />
                  </button>
                </Tooltip>
              ) : null}
            </>
          );
        })}
      </div>
    );
  };
  React.useMemo(() => {
    populateTable();
  }, [listingObject?.searchString, listingObject?.searchId]);
  return (
    <div className="px-2 mt-12">
      <div>
        <div>
          <h1 className="text-center mt-4 text-black font-bold text-xl font-Poppins my-2">
            Pass Type
          </h1>
        </div>
        <div className="grid grid-cols-[70%_29.5%] gap-2 mt-3">
          <div className="grid grid-cols-1 lg:grid-cols-[35%_10%] md:grid-cols-[50%_10%] gap-3">
            <SearchDropdown
              name="passType"
              placeholder="Search by Pass Type Name"
              handleInputChange={(e) => {
                if (e !== "" && UseCheckConsecutiveCharacters(e)) {
                  passTypeBySearchString(e)
                    .then((response) => response.data)
                    .then((res) => {
                      setPassTypeOptions(res.result);
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                } else {
                  setPassTypeOptions([]);
                }
              }}
              inputRef={{
                ...register("passType", {
                  onChange: (e) => {
                    let value = e?.target?.value;
                    console.log("valuevaluevalue", value);

                    if (value !== null) {
                      setSearchString(value);
                    } else if (value === null) {
                      setSearchString(null);
                      setListingObject((listingObject) => ({
                        ...listingObject,
                        searchId: null,
                      }));
                    }
                  },
                }),
              }}
              dataArray={passTypeOptions}
              control={control}
              searchIcon={true}
              isClearable={true}
            />

            <div className="flex gap-1">
              {/* <CheckBoxField
								name='Status'
								control={control}
								label='Active'

							/> */}

              <div className=" flex gap-x-2">
                <CommonButton
                  searchIcon={true}
                  className="bg-customBlue text-white"
                  onClick={() => {
                    // populateTable();
                    setListingObject((listingObject) => ({
                      ...listingObject,
                      searchString: "",
                      searchId: searchString?.value
                        ? searchString?.value
                        : null,
                    }));
                  }}
                />
                <CommonButton
                  label={"Reset"}
                  className=" border border-customRed text-customRed "
                  onClick={() => {
                    setSearchString(null);
                    setListingObject((listingObject) => ({
                      ...listingObject,
                      searchString: "",
                      searchId: null,
                    }));
                    setValue("passType", null);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="grid justify-end">
            {userAction?.map((option, i) =>
              !option.isAction && option.permission === "Create" ? (
                <CommonButton
                  label="+ New"
                  className="modalOpenButton bg-customBlue text-white"
                  onClick={() => setAddNewPassTypeModal(true)}
                />
              ) : null
            )}
          </div>
        </div>
      </div>

      {addNewPassTypeModal && (
        <PassTypeModal
          addNewPassTypeModal={addNewPassTypeModal}
          setAddNewPassTypeModal={setAddNewPassTypeModal}
          populateTable={populateTable}
          isBackDrop={isBackDrop}
          setIsBackdrop={setIsBackdrop}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      )}
      <div className="">
        {isShowSpinner ? (
          <div className="flex justify-center my-28">
            <LoadingSpinner />
          </div>
        ) : (
          <div>
            {dataResult && dataResult.length > 0 ? (
              <CommonMasterPaginationTable
                dataResult={dataResult}
                rowsPerPage={rowsPerPage}
                renderActions={renderActions}
                setPage={setPage}
                tableClass="capitalize"
                count={count}
                page={page}
                populateTable={populateTable}
                highlightRow={false}
                setRowsPerPage={setRowsPerPage}
                removeHeaders={["Id"]}
                renderInput={renderInput}
                editableColumns={["Time Format", "Duration"]}
              />
            ) : (
              <>
                {!isShowSpinner && (
                  <p className="text-center  my-28 w-full text-gray-600">
                    No Record Found<span className="animate-pulse">...</span>
                  </p>
                )}
              </>
            )}
          </div>
        )}
      </div>
      <div>
        {deleteConfirmationModal && (
          <ConfirmationModal
            confirmationOpen={deleteConfirmationModal}
            confirmationHandleClose={() => {
              setDeleteConfirmationModal(false);
              setSelectedRow(null);
            }}
            confirmationSubmitFunc={handleConfirmToDelete}
            confirmationMsg={"Are you sure to Delete the Record?"}
            confirmationButtonMsg={"OK"}
            confirmationLabel={"Confirmation"}
          />
        )}
      </div>
      {isBackDrop && <CommonBackDrop openBackdrop={isBackDrop} />}
    </div>
  );
}

export default PassType;
